import DropzoneWidget from './dropzone-widget';

const dropzoneWidgetConfig = {
  name: 'dropzoneWidget',
  class: DropzoneWidget,
  querySelector: {
    customHtmlWidget: '.custom-html-widget',
  },
  options: {
    // This class is added in Dropzones_Feature_Definition::filter_dynamic_sidebar_params_callback.
    zIndexStackingResetClass: 'widget--has-z-index-stacking-reset',
  },
};

export default dropzoneWidgetConfig;
